export default {
  namespaced: true,
  state: {
    sidebarVisible: false,
    currentPanel: null // { title: 'Search', component: 'search-panel' }
  },
  getters: {
    currentPanelComponent: state => state.currentPanel ? state.currentPanel.component : null,
    currentPanelTitle: state => state.currentPanel ? state.currentPanel.title : ''
  },
  mutations: {
    setSidebarVisible (state, visible) {
      state.sidebarVisible = visible;
    },
    setCurrentPanel (state, panel) {
      state.currentPanel = panel;
      if (panel) {
        state.sidebarVisible = true;
      }
    },
    toggleSidebar (state) {
      state.sidebarVisible = !state.sidebarVisible;
    }
  },
  actions: {
    openPanel ({ commit }, panel) {
      commit('setCurrentPanel', panel);
    },
    closeSidebar ({ commit }) {
      commit('setSidebarVisible', false);
    }
  }
}
